import { useTranslation } from 'react-i18next';

export const MeetingSecretaryTemplates = () => {
  const { t } = useTranslation();

  return (
    <div className="flex-1 overflow-auto bg-background p-12">
      <div className="mb-8">
        <h1 className="text-3xl font-semibold">{t('meeting-secretary.templates.title')}</h1>
        <p className="text-gray-600 mt-2">{t('meeting-secretary.templates.description')}</p>
      </div>

      {/* Placeholder content */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Coming Soon</h3>
        <p className="text-gray-600">Templates functionality will be available here.</p>
      </div>
    </div>
  );
};
